import { render, staticRenderFns } from "./TeamBrainICP.vue?vue&type=template&id=557d1aae&scoped=true&"
import script from "./TeamBrainICP.vue?vue&type=script&lang=js&"
export * from "./TeamBrainICP.vue?vue&type=script&lang=js&"
import style0 from "./TeamBrainICP.vue?vue&type=style&index=0&id=557d1aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d1aae",
  null
  
)

export default component.exports